<template>
  <div class="saving">
    <img src="~@/assets/icons/spinner.svg"/>
    <p class="text--bold" :class="textClass">{{text}}</p>
  </div>
</template>

<script>
export default {
  name: "LoadingIndicator",
  props: {
    large: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: 'Loading...'
    }
  },
  computed: {
    textClass() {
      return this.large ? 'text--l' : 'text--m';
    }
  }
}
</script>

<style scoped lang="scss">
.saving {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  flex-wrap: nowrap;

  img {
    width: 40px;
    height: 40px;
    animation: spin 1.5s linear infinite;
  }

  p {
    color: #505050;
    margin: 20px 0 0;
  }
}
</style>
